<!--
Detail :
  ## 공사현장 단위로 조회 (전체 조회 X)
  ## 안전보건관리비 사용계획이 다 작성되어 제출된 공사현장에 대해서 조회
 *
examples:
 *
-->
<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <template v-if="!unavailable">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <!-- <c-plant type="none" name="plantCd" v-model="searchParam.plantCd" /> -->
            <c-select
              :comboItems="plantItems"
              itemText="plantName"
              itemValue="plantCd"
              type="none"
              name="plantCd"
              label="공사현장 (* 사용계획이 제출된 공사현장)"
              v-model="searchParam.plantCd"
            ></c-select>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-datepicker
              type="month"
              default="today"
              label="조회 월(해당 월 기준으로 과거 정보를 취합)"
              name="month"
              v-model="searchParam.month"
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-text
              :afterIcon="
                [
                  {
                    name: 'search',
                    click: true,
                    callbackName: 'searchVendor',
                  },
                  {
                    name: 'close',
                    click: true,
                    callbackName: 'removeVendor',
                  },
                ]
              "
              :editable="editable"
              :readonly="true"
              :plantCd="searchParam.plantCd"
              label="사용업체"
              name="vendorName"
              v-model="searchParam.vendorName"
              @searchVendor="searchVendor"
              @removeVendor="removeVendor"
            >
            </c-text>
          </div>
        </template>
        <template v-else>
          <q-chip class="unavailable-tag" color="red" text-color="white" icon="priority_high" label="사용계획이 제출된 공사현장이 없습니다. 제출 후 이용바랍니다." outline square/>
        </template>
      </template>
    </c-search-box>
    <c-card title="공사현장 사용계획 정보" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group v-if="isPlant" outline>
          <c-btn 
            :disabled="unavailable"
            label="사용내역서" 
            icon="print"
            @btnClicked="print" />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
        <q-btn-group v-else outline>
          <font style="font-size:0.8em;font-weight:300;" class="blinking" color="#C10015">
            ※ 공사현장관리 메뉴에서 공사현장을 추가하세요.
          </font>
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-4 col-md-2 col-lg-2">
          <c-text
            :disabled="true"
            :editable="editable"
            label="공사기간"
            name="projectPeriod"
            v-model="plant.projectPeriod"
          />
        </div>
        <div class="col-xs-12 col-sm-4 col-md-2 col-lg-2">
          <c-text
            :disabled="true"
            :editable="editable"
            type="number"
            label="사업금액(원)"
            name="projectCost"
            v-model="plant.projectCost">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-4 col-md-2 col-lg-2">
          <c-text
            :disabled="true"
            :editable="editable"
            type="number"
            label="안전보건관리비 예산(원)"
            name="projectSafetyCost"
            v-model="plant.projectSafetyCost">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-4 col-md-2 col-lg-2">
          <c-text
            :disabled="true"
            :editable="editable"
            type="number"
            label="전체 누적사용액(원)"
            name="stackAmount"
            v-model="plant.stackAmount">
          </c-text>
        </div>
      </template>
    </c-card>
    <c-table
      ref="table"
      class="q-mt-md"
      title="사용내역서"
      tableId="performanceSMF"
      :columns="grid.columns"
      :merge="grid.merge"
      :data="plant.statementItemUse"
      :columnSetting="false"
      :expandAll="false"
      :isFullScreen="false"
      :usePaging="false"
      :hideBottom="true"
      :filtering="false"
    >
      <template v-if="plant.stackAmounts && plant.stackAmounts.length>0"  slot="suffixTitle">
        <font class="text-negative" style="font-size:0.8em;font-weight:300;">
          ※ 업체별 누적사용액 
        </font>
        <q-chip
          v-for="(stack, index) in plant.stackAmounts"
          :key="index"
          outline square 
          color="primary"
          text-color="white"
          class="q-ma-none customchipdept">
          <template>
            {{ '[' + stack.vendorName +'] ' }}
            {{stack.stackAmount + '원'}}
          </template>
        </q-chip>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import selectConfig from '@/js/selectConfig';
export default {
  name: 'statment-item-use',
  data() {
    return {
      searchParam: {
        plantCd: null,
        month: null,
        vendorCd: '',
        vendorName: '',
        innerFlag: '',
      },
      plant: {
        plantCd: null,
        plantName: null,
        projectPeriod: null,
        projectSafetyCost: 0,
        stackAmount: 0,
        projectAddress: '',
        projectCost: 0,
        vendorCds: '',
        statementItemUse: [],
        stackAmounts: [],
      },
      grid: {
        merge: [
          { index: 0, colName: 'vendorCd' },
        ],
        columns: [
          {
            name: 'vendorName',
            field: 'vendorName',
            label: '업체',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'smfItemName',
            field: 'smfItemName',
            label: 'LBLITEMS',
            align: 'left',
            style: 'width:300px',
            sortable: false,
          },
          {
            name: 'amountTobeUsed',
            field: 'amountTobeUsed',
            label: '총 예산(A)',
            align: 'right',
            style: 'width:150px',
            sortable: false,
            type: 'cost',
          },
          {
            name: 'monthlyUsage',
            field: 'monthlyUsage',
            label: '당월 사용액',
            align: 'right',
            style: 'width:120px',
            sortable: false,
            type: 'cost',
          },
          {
            name: 'stackAmount',
            field: 'stackAmount',
            label: '누적 사용액(B)',
            align: 'right',
            style: 'width:150px',
            sortable: false,
            type: 'cost',
          },
          {
            name: 'balance',
            field: 'balance',
            label: '잔액(A - B)',
            align: 'right',
            style: 'width:150px',
            sortable: false,
            type: 'cost',
          },
          {
            name: 'rate',
            field: 'rate',
            label: '사용비율(%)',
            align: 'right',
            style: 'width:100px',
            sortable: false,
            type: 'cost',
          },
        ],
        data: [],
      },
      plantItems: [],
      unavailable: false,
      editable: true,
      listUrl: '',
      printUrl: '',
      vendorItems: [],
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      isPlant: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.usePlanListUrl = selectConfig.smf.usePlan.list.url;
      this.listUrl = selectConfig.smf.statementItemUse.vendor.list.url;
      this.printUrl = selectConfig.smf.statementItemUse.vendor.print.url;
      if (!this.$store.getters.user.plantCds) {
        this.isPlant = false;
      }
      // code setting
      // list setting
      this.getPlantItems();
    },
    getPlantItems() {
      this.$http.url = this.usePlanListUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        smfUsePlanStepCd: 'SUP0000005'
      }
      this.$http.request((_result) => {
        this.plantItems = _result.data;
        if (this.plantItems && this.plantItems.length > 0) {
          if (this.$_.findIndex(this.plantItems, { plantCd: this.$store.getters.user.plantCd }) > -1) {
            this.$set(this.searchParam, 'plantCd', this.$store.getters.user.plantCd);
          } else {
            this.$set(this.searchParam, 'plantCd', this.plantItems[0].plantCd);
          }
          this.unavailable = false;
          this.getList();
        } else {
          this.unavailable = true;
        }
      },);
    },
    getList() {
      if (this.unavailable) return;
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.plant = this.$_.clone(_result.data)
      },);
    },
    print() {
      let thisVue = this;
      this.$http.url = this.printUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request(
        _result => {
          let fileOrgNm = this.plant.plantName + '업체별 산업안전보건관리비 사용내역서.docx';
          let blob = thisVue.$comm.base64ToBlob(_result.data);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
          } else {
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileOrgNm;
            link.click();
          }
        }, () => { }
      );
    },
    searchVendor() {
      this.popupOptions.title = '업체 검색';
      this.popupOptions.param = {
        type: 'single',
        plantCd: this.searchParam.plantCd,
        vendorCds: this.plant.vendorCds ? 
          this.plant.vendorCds.split(",") : [],
      };
      this.popupOptions.target = () => import(`${'@/pages/common/vendor/vendorPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.searchParam.vendorCd = data[0].vendorCd
        this.searchParam.vendorName = data[0].vendorName
      }
    },
    removeVendor() {
      this.searchParam.vendorCd = '';
      this.searchParam.vendorName = '';
    }
  }
};
</script>
